import { CheckIcon, XIcon } from 'lucide-react';

interface BooleanCellProps {
  value: boolean;
}

export function BooleanCell({ value }: BooleanCellProps) {
  return value ? <CheckIcon className=" text-green-700" /> : <XIcon className=" text-orange-700" />;
}
